export default __webpack_public_path__ + "static/media/Rocket_DAO-Block.4b7487aa.svg";